var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feature_card"},[_c('div',{staticClass:"feat"},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":_vm.item.icon}})]),_c('div',{staticClass:"title"},[_c('h4',[_vm._v(_vm._s(_vm.item.title))])]),_c('div',{staticClass:"desc"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }